import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import { BASE_URL } from "../../url";
import { Link } from "react-router-dom";
import { FaClock, FaRegCalendarAlt, FaMapMarker } from 'react-icons/fa';
import Col from 'react-bootstrap/Col';
import placeholderImage from '../../images/placeholder.png';
import { Spinner } from 'react-bootstrap';
import { BiLogoWhatsapp } from "react-icons/bi";

function DisplayTreks() {
  const [getAllTreks, setAllTreks] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}/getAllTreks`)
      .then(response => {
        response.json().then(getAllTreks => {
          setAllTreks(getAllTreks);
          setLoading(false);
        });
      });
  }, []);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" role="status" className='trekNameWhite'>
        </Spinner>
      </div>
    ); 
  }

  if (getAllTreks) {
    return (
      <CardGroup className='aboutTop'>
        <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=919535117707&text=Hi, Hoolla's Trekking!" class="whatsapp-button"><BiLogoWhatsapp/></a>
        {getAllTreks.map((trekData, k) => (
          <Col key={k} xs={12} md={3} lg={4}>
            <Card className='cardBody'>
              <Card.Img
                variant="top"
                className='trekImage'
                src={trekData.thumbnailImage || placeholderImage}
                alt="Trek Thumbnail"
                style={{ width: '300px', height: '200px', objectFit: 'cover' }}
                loading="lazy"
              />
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <Card.Title className="trekName">{trekData.trekName}</Card.Title>
                  <span className="trekPrice">₹{trekData.trekPrice.toLocaleString('en-IN')}</span>
                </div>
                <div className='trekLine'><FaClock /> &nbsp; {(trekData.numberOfDays)} Days</div>
                <div className='trekLine'><FaRegCalendarAlt /> &nbsp; {(new Date(trekData.startDate)).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} To {(new Date(trekData.endDate)).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
                <div className='trekLine'><FaMapMarker /> &nbsp; {(trekData.trekLocation)}</div> <hr />
                <a href={`/trekDetails/` + trekData._id} className="btn-get-started">VIEW DETAILS</a>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </CardGroup>
    );
  }
}

export default DisplayTreks;